import React from 'react';
import { useIsEmbeddedMobile } from '../../../_hooks/useIsEmbeddedMobile';
import { StyledPageWrapper } from './Positions.styles';
import { AlternativeDetail } from './components/AlternativeDetail/AlternativeDetail';
import { DateSelector } from './components/DateSelector/DateSelector';
import { PositionsTable } from './components/PositionsTable/PositionsTable';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../CommonComponents/OPL/Text/Text';
import { MobileHeader } from '../../components/MobileHeader/MobileHeader';
import { MobileHelperText } from '../../components/MobileHelperText/MobileHelperText';

interface Props {
  selectedItemName: string;
  updatedAt: string;
}

export const Positions = ({ selectedItemName, updatedAt }: Props) => {
  const isEmbeddedMobile = useIsEmbeddedMobile();

  return (
    <>
      <StyledPageWrapper isEmbeddedMobile={isEmbeddedMobile}>
        {isEmbeddedMobile && (
          <Box px="16">
            <MobileHeader label={selectedItemName} subLabel={`Last updated: ${updatedAt}`} />

            <Text
              fontWeight={600}
              color="neutral.600"
              fontSize="small"
              css="white-space: nowrap"
              mt="24"
              mb="4"
            >
              As of
            </Text>

            <DateSelector isEmbeddedMobile={isEmbeddedMobile} />
          </Box>
        )}

        <PositionsTable isEmbeddedMobile={isEmbeddedMobile} />

        {!isEmbeddedMobile && <AlternativeDetail />}
      </StyledPageWrapper>

      <MobileHelperText />
    </>
  );
};
